exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".media-content[data-v-beb4a790]{width:100%;max-width:1200px}.header[data-v-beb4a790]{height:106px;background:#6d43a1;display:flex;flex-direction:row;justify-content:center;z-index:2}.header .content[data-v-beb4a790]{width:100%;max-width:1200px;height:100%;display:flex;flex-direction:row;align-items:center;justify-content:space-between}.header .content .logo[data-v-beb4a790]{width:98px;height:75px}.header .content .buttons[data-v-beb4a790]{display:flex;flex-direction:row;align-items:center;line-height:36px;font-size:18px;color:#fff;height:100%;font-family:ArialMT,Helvetica,Arial,sans-serif}.header .content .buttons .button[data-v-beb4a790]{height:100%;box-sizing:border-box;display:flex;flex-direction:row;align-items:center;padding:20px 10px 0;cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-beb4a790","scoped":true,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/e-header.vue
// module id = 146
// module chunks = 0